// extracted by mini-css-extract-plugin
module.exports = {"label":"PaymentSelect_label__3B3xg","select":"PaymentSelect_select__2DXyL"};